/*
 * Product pages.
 */

export const SEGMENT_CMC = "Commercial Aviation";
export const SEGMENT_CMC_ID = "commercial-aviation";
export const SEGMENT_BZA = "Business Jet";
export const SEGMENT_BZA_ID = "business-jets";
export const URL_BZA_AIRCRAFT_DATA = "/products/aircraft-data";
export const URL_BZA_AIRCRAFT_ACCIDENTS_AND_INCIDENTS_DATA =
	"/products/aircraft-accidents-and-incidents-data";
export const URL_BZA_AIRCRAFT_HISTORY_DATA = "/products/aircraft-history-data";
export const URL_BZA_AIRCRAFT_OWNERSHIP_DATA =
	"/products/aircraft-ownership-data";
export const URL_BZA_OPERATOR_CONTACT_DATA = "/products/operator-contact-data";
export const URL_BZA_OPERATOR_AIRPORT_DATA = "/products/operator-airport-data";
export const URL_CMC_AIRCRAFT_ACCIDENTS_AND_INCIDENTS_DATA =
	"/products/aircraft-accidents-and-incidents-data";
export const URL_CMC_AIRCRAFT_DATA = "/products/aircraft-data";
export const URL_CMC_AIRCRAFT_OWNERSHIP_DATA =
	"/products/aircraft-ownership-data";
export const URL_CMC_AIRCRAFT_HISTORY_DATA = "/products/aircraft-history-data";
export const URL_CMC_AIRFRAME_MRO_PROVIDER_DATA =
	"/products/airframe-mro-provider-data";
export const URL_CMC_AIRFRAME_MRO_EVENT_DATA =
	"/products/airframe-mro-event-data";
export const URL_CMC_OPERATOR_AIRPORT_DATA = "/products/operator-airport-data";
export const URL_CMC_OPERATOR_CAPACITY_DATA =
	"/products/operator-capacity-data";
export const URL_CMC_OPERATOR_CONTACTS_DATA = "/products/operator-contact-data";
export const URL_CMC_OPERATOR_IT_DATA = "/products/operator-it-data";
export const URL_CMC_OPERATOR_SCHEDULE_DATA =
	"/products/operator-schedule-data";
export const URL_DATA_FEEDS = "https://data.ch-aviation.com/";
export const TRIAL_DEFAULT_DESCRIPTION =
	"Get full, unrestricted access to all of ch-aviation’s news and data for 14 days. Our no-commitment guarantee";
